export default {
  directive: 'tooltip',
  component: 'tippy',
  componentSingleton: 'tippy-singleton',
  defaultProps: {
    theme: 'dark',
    placement: 'auto',
    allowHTML: true,
  },
};
